module.exports = __webpack_public_path__ + "static/media/view1.1a5edd9f.jpeg";